import { useEffect, useRef } from 'react';
import useVoice from '../../../app/hooks/useVoice';

const VoiceButton = ({
  command,
  param,
  paramValue,
  onClick,
  children,
  className,
  disabled,
  buttonType
}) => {
  const { isListening, action, actionExecuted } = useVoice();
  const prevActionRef = useRef(null);

  // Split commands and create data attributes dynamically
  const commandList = command ? command.split(',').map(cmd => cmd.trim()) : [];
  const commandAttributes = commandList.reduce((attrs, cmd, index) => {
    attrs[`data-command-${index + 1}`] = cmd.toLowerCase();
    return attrs;
  }, {});

  useEffect(() => {
    if (!action || !action.command) return;
    // Avoid re-triggering if action hasn't actually changed
    if (prevActionRef.current && prevActionRef.current.id === action.id) {
      return;
    }

    // Update stored action reference
    prevActionRef.current = action;

    if (command.toLowerCase() === action.command.toLowerCase()) {
      if (param && paramValue) {
        if (
          action?.params &&
          action?.params.hasOwnProperty(param) &&
          action?.params[param] === paramValue
        ) {
          actionExecuted(action);
          !disabled && onClick && onClick();
        }
      } else {
        actionExecuted(action);
        !disabled && onClick && onClick();
      }
    }
  }, [action]);

  return buttonType && buttonType === 'LINK' ? (
    <a
      onClick={onClick}
      {...commandAttributes} // Add dynamic data-command attributes
      data-title={'Command: ' + command}
      disabled={disabled}
      className={isListening && !disabled ? className + ' voice-button-listening1' : className}
    >
      {children}
    </a>
  ) : (
    <button
      onClick={onClick}
      {...commandAttributes} // Add dynamic data-command attributes
      data-title={'Command: ' + command}
      disabled={disabled}
      className={isListening && !disabled ? className + ' voice-button-listening1' : className}
    >
      {children}
    </button>
  );
};

export default VoiceButton;
